import { render } from "./introduce-row.vue?vue&type=template&id=fd8dfe50"
import script from "./introduce-row.vue?vue&type=script&lang=ts"
export * from "./introduce-row.vue?vue&type=script&lang=ts"
script.render = render

export default script